import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

// The pot totals as one row of figures. Every number is calculated by the backend, so nothing here
// adds anything up.

const TILES = [
     { key: "totalPrizeQty", label: "Total prizes" },
     { key: "availableToWinQty", label: "Available to play" },
     { key: "wonQty", label: "Won" },
     { key: "totalBudgetValueGbp", label: "Total Budget", isMoney: true },
     { key: "valueWonGbp", label: "Value won", isMoney: true },
     { key: "outstandingGameCodeCount", label: "Codes still to play" },
];

const money = (value) =>
     new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
          maximumFractionDigits: 0,
     }).format(value || 0);

export default function LcvPrizePotSummary(props) {
     const { prizePot, authorisedGbp } = props;

     return (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 3 }}>
               <Paper variant="outlined" sx={{ px: 3, py: 2, minWidth: 160 }}>
                    <Typography variant="caption" color="text.secondary">
                         Authorised
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                         {money(authorisedGbp)}
                    </Typography>
               </Paper>

               {TILES.map((tile) => (
                    <Paper key={tile.key} variant="outlined" sx={{ px: 3, py: 2, minWidth: 160 }}>
                         <Typography variant="caption" color="text.secondary">
                              {tile.label}
                         </Typography>
                         <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                              {tile.isMoney
                                   ? money(prizePot?.[tile.key])
                                   : prizePot?.[tile.key] ?? 0}
                         </Typography>
                    </Paper>
               ))}
          </Box>
     );
}
